import * as types from '../types'

const state = {
  isCollapse: false
}

const getters = {
  isCollapse:()=>{
    return state.isCollapse;
  }
}

const actions = {

}

const mutations = {
  [types.CHANGECOLLAPSE](state,playload){
    state.isCollapse = !state.isCollapse;
  },
  [types.CHANGEWIDTH](state,playload){
    state.isCollapse = window.innerWidth < 1280 ? true : false;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/collapse.js